import React from 'react'
import styled from 'styled-components'

export type Props = {
  label: string,
  buttonType: ButtonType,
} &  React.ButtonHTMLAttributes<HTMLButtonElement>

export type ButtonType = 'PRIMARY' | 'SECONDARY'

const StyledButtonBase = styled.button`
  width: 15rem;
  border: none;
  border-radius: 20rem;
  font-size: .875rem;
  font-weight: bold;
  height: 2.875rem;
  line-height: 2.875rem;
  padding: 0 .75rem;
  text-align: center;

  @include @media ${props => props.theme.media.sm} {
    width: 100%;
  }

  &:focus {
    outline: 0;
  }

  &:hover {
    text-decoration: none;
  }

  &:disabled {
    background: #dbdde3;
    color: ${props => props.theme.clients.colors.silver._70};
    opacity: 1;

    &:hover {
      color: ${props => props.theme.clients.colors.silver._70};
      cursor: no-drop;
    }
  }
`

const StyledPrimaryButton = styled(StyledButtonBase)`
`

const StyledSecondaryButton = styled(StyledButtonBase)`
  color: ${props => props.theme.clients.colors.white};
  background: ${props => props.theme.clients.colors.lightGreen};

  &:hover {
    background: ${props => props.theme.clients.colors.greenishTeal};
  }

  &:not(:disabled):not(.disabled):active,
  &:not(:disabled):not(.disabled):focus {
    background: ${props => props.theme.clients.colors.greenishTeal};
    box-shadow: none;
  }
`

export const StyledButton: React.FC<Props> = ({ label, buttonType, ...buttonProps }: Props) => {
  switch (buttonType) {
    case 'PRIMARY':
      return <StyledPrimaryButton {...buttonProps}>{label}</StyledPrimaryButton>
    case 'SECONDARY':
      return <StyledSecondaryButton {...buttonProps}>{label}</StyledSecondaryButton>
    default:
      return <StyledPrimaryButton {...buttonProps}>{label}</StyledPrimaryButton>
  }
}
